<template>
  <div class="market-history markets-pair-list">
    <mainHeader title="ACCOUNT RECORDS"></mainHeader>
    <div style="padding: 0 12px;">


    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active"
          id="left-goes-on-tab"
          data-bs-toggle="tab"
          data-bs-target="#left-goes-on"
          type="button"
          role="tab"
          aria-controls="left-goes-on"
          aria-selected="true"
        >
          Life goes on
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="history-tab"
          data-bs-toggle="tab"
          data-bs-target="#history"
          type="button"
          role="tab"
          aria-controls="history"
          aria-selected="true"
        >
          History
        </button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="left-goes-on"
        role="tabpanel"
        aria-labelledby="left-goes-on-tab"
      >
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Currency Pair</th>
                <th>Position Types</th>
                <th>Num</th>
                <th>Buying rate</th>
                <th>Buying time</th>
                <th>The order time</th>
                <th>Time remaining</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data1" :key="item.id">
                <td>{{ item.bi_name }}</td>
                <td :class="item.type == 1 ? 'text-success' : 'text-danger'">{{ item.type == 1 ? "Long" : "Short" }}</td>
                <td>{{ item.money }}</td>
                <td>{{ item.start_money }}</td>
                <td>{{ formatTime(item.addtime) }}</td>
                <td>{{ item.hold_time }}s</td>
                <td>{{ "00:00:00" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination
          v-if="page1.total > page1.pageSize"
          :total="page1.total"
          :pageSize="page1.pageSize"
          v-model:currentPage="page1.currentPage"
          @change="handlePageChange1"
        />
      </div>
      <div
        class="tab-pane fade"
        id="history"
        role="tabpanel"
        aria-labelledby="history-tab"
      >
        <div class="table-responsive">
          <table cellpadding="0" class="table">
            <thead>
              <tr>
                <th scope="col">Currency Pair</th>
                <th scope="col">Position Types</th>
                <th scope="col">Trade Size</th>
                <th scope="col">Profit loss</th>
                <th scope="col">Buying rate</th>
                <th scope="col">Selling rate</th>
                <th scope="col">The order time</th>
                <th scope="col">Buying time</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data2" :key="item.id">
                <td scope="row">{{ item.bi_name }}</td>
                <td :class="item.type == 1 ? 'text-success' : 'text-danger'">{{ item.type == 1 ? "Long" : "Short" }}</td>
                <td>{{ item.money }}</td>
                <td>{{ item.win_money }}</td>
                <td>{{ item.start_money }}</td>
                <td>{{ item.end_money }}</td>
                <td>{{ item.hold_time }}s</td>
                <td>{{ formatTime(item.endtime) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination
          v-if="page2.total > page2.pageSize"
          :total="page2.total"
          :pageSize="page2.pageSize"
          v-model:currentPage="page2.currentPage"
          @change="handlePageChange2"
        />
      </div>
    </div>
     </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { getUserSpeedOrderList } from "@/apis/wallet";
import Pagination from "@/components/Pagination.vue";
import mainHeader from '@/components/mainHeader.vue';
export default {
  data() {
    return {
      data1: [],
      data2: [],
      page1: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      page2: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
    };
  },
  components: {
    Pagination,
    mainHeader
  },
  methods: {
    formatTime(time) {
      return dayjs(time * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    getData1() {
      getUserSpeedOrderList({
        status: 1,
        page: this.page1.currentPage,
        rows: this.page1.pageSize,
      }).then((res) => {
        console.log(res);
        this.data1 = res.data;
        this.page1.total = res.count;
      });
    },
    getData2() {
      getUserSpeedOrderList({
        status: 2,
        page: this.page2.currentPage,
        rows: this.page2.pageSize,
      }).then((res) => {
        console.log(res);
        this.data2 = res.data;
        this.page2.total = res.count;
      });
    },
    handlePageChange1(page) {
      console.log(page);
      this.getData1();
    },
    handlePageChange2(page) {
      console.log(page);
      this.getData2();
    },
  },
  created() {
    this.getData1();
    this.getData2();
  },
};
</script>

<style></style>
